<div class="footer" *ngIf="usuarioAutenticado">
    <div class="footer-flex">
        <div class="footer-block">
            <div class="footer-item">
                <h1><b>Gestão Credipontal</b></h1>
            </div>
        </div>
        <div class="footer-block">
            <div class="footer-item">
                <a><h2><b>Links úteis:</b></h2></a>
                <a href="http://www.sicoobcredipontal.com.br/"><h2>Credipontal</h2></a>
                <a href="http://www.sicoobcentralcecremge.com.br"><h2>Central Cecremge</h2></a>
                <a href="http://www.sicoob.com.br"><h2>Sicoob</h2></a>
                <a href="http://sipag.com.br"><h2>Sipag</h2></a>
            </div>
        </div>
        <div class="footer-block">
            <div class="footer-item">
                <h2><b>Cooperativa de Crédito de Livre Admissão do Pontal do Triângulo</b></h2>
                <h2>Rua Trinta e Seis nº 800 - bairro Progresso</h2>
                <h2>38.302-008 - Ituiutaba-MG</h2>
                <h2><mat-icon>phone</mat-icon>  34-3271-4300</h2>
            </div>
        </div>
    </div>
    <div class="footer-copy">
        © 2021 Copyright: Gestão Credipontal - Contatos: (34) 9-9973-1503
    </div>
</div>